/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */

import PaletteIconCheckbold from '@telus-uds/palette-allium/build/rn/icons/Checkbold'
const theme = {
  appearances: {
    background: {
      type: 'variant',
      values: [ 'alternative', 'subtle', 'grid', 'feature', 'plain' ]
    },
    borderRadius: { type: 'variant', values: [ 'none', 'small', 'large' ] },
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    interactive: { type: 'variant', values: [ true ] },
    isControl: { type: 'variant', values: [ true, false ] },
    padding: {
      type: 'variant',
      values: [ 'narrow', 'intermediate', 'compact', 'custom' ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    },
    selected: {
      description: 'Applies while an interactive component is the currently selected one in a set of states or components, for example a button in a `ButtonGroup`.',
      type: 'state',
      values: [ true ]
    },
    style: {
      type: 'variant',
      values: [
        'grid',     'light',
        'lighter',  'lightest',
        'dark',     'darker',
        'darkest',  'feature',
        'feature2', 'feature3',
        'feature4', 'warning',
        'error',    'success'
      ]
    },
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { interactive: true, isControl: true },
      tokens: { borderColor: '#b2b9bf', borderWidth: 1 }
    },
    {
      if: { interactive: true, isControl: true, selected: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#4b286d',
        borderWidth: 1,
        iconBackgroundColor: '#e3e6e8',
        iconColor: '#4b286d',
        inputBackgroundColor: '#e3e6e8'
      }
    },
    {
      if: { hover: true, interactive: true, isControl: true },
      tokens: { iconColor: '#414547' }
    },
    {
      if: {
        focus: false,
        interactive: true,
        isControl: true,
        pressed: false
      },
      tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 2 }
    },
    {
      if: {
        hover: true,
        interactive: true,
        isControl: true,
        selected: true
      },
      tokens: {
        iconBackgroundColor: '#e3e6e8',
        iconColor: '#414547',
        inputBackgroundColor: '#e3e6e8'
      }
    },
    { if: { borderRadius: 'none' }, tokens: { borderRadius: 0 } },
    { if: { borderRadius: 'small' }, tokens: { borderRadius: 6 } },
    { if: { borderRadius: 'large' }, tokens: { borderRadius: 12 } },
    {
      if: { background: 'alternative' },
      tokens: { backgroundColor: '#f4f4f7' }
    },
    {
      if: { background: 'subtle' },
      tokens: { backgroundColor: '#fafafa' }
    },
    {
      if: { background: 'feature' },
      tokens: {
        borderColor: '#4b286d',
        borderWidth: 2,
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { background: 'grid' },
      tokens: { backgroundColor: '#fafafa', borderWidth: 0 }
    },
    {
      if: { background: 'plain' },
      tokens: { backgroundColor: '#ffffff', borderWidth: 0 }
    },
    {
      if: { style: 'grid' },
      tokens: { backgroundColor: '#fafafa', borderWidth: 0 }
    },
    { if: { style: 'light' }, tokens: { backgroundColor: '#f4f4f7' } },
    {
      if: { style: 'lighter' },
      tokens: { backgroundColor: '#fafafa' }
    },
    {
      if: { style: 'lightest' },
      tokens: { backgroundColor: '#ffffff', borderWidth: 0 }
    },
    {
      if: { style: 'dark' },
      tokens: {
        backgroundColor: '#4b286d',
        backgroundGradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        },
        borderColor: '#4b286d',
        borderWidth: 1
      }
    },
    {
      if: { style: 'darker' },
      tokens: { backgroundColor: '#4b286d', borderWidth: 0 }
    },
    {
      if: { style: 'darkest' },
      tokens: { backgroundColor: '#2c2e30', borderWidth: 0 }
    },
    {
      if: { style: 'feature' },
      tokens: {
        borderColor: '#4b286d',
        borderWidth: 2,
        gradient: {
          angle: 135,
          stops: [
            { color: '#4b286d', hint: 0.75, stop: 0 },
            { color: '#e53293', stop: 1 }
          ],
          type: 'linear'
        }
      }
    },
    {
      if: { style: 'feature2' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#e3e6e8',
        borderWidth: 1
      }
    },
    {
      if: { style: 'feature3' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#e3e6e8',
        borderWidth: 1
      }
    },
    {
      if: { style: 'feature4' },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#e3e6e8',
        borderWidth: 1
      }
    },
    {
      if: { style: 'warning' },
      tokens: {
        backgroundColor: '#fff9ee',
        borderColor: '#faca69',
        borderWidth: 1
      }
    },
    {
      if: { style: 'error' },
      tokens: {
        backgroundColor: '#ffffff',
        borderColor: '#e12339',
        borderWidth: 1
      }
    },
    {
      if: { style: 'success' },
      tokens: {
        backgroundColor: '#f4f9f2',
        borderColor: '#2b8000',
        borderWidth: 1
      }
    },
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        paddingBottom: 48,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 48
      }
    },
    {
      if: { interactive: true, viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        paddingBottom: 45,
        paddingLeft: 29,
        paddingRight: 29,
        paddingTop: 45
      }
    },
    {
      if: { padding: 'narrow' },
      tokens: {
        paddingBottom: 24,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 24
      }
    },
    {
      if: { interactive: true, padding: 'narrow' },
      tokens: {
        paddingBottom: 21,
        paddingLeft: 13,
        paddingRight: 13,
        paddingTop: 21
      }
    },
    {
      if: { padding: 'narrow', viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        paddingBottom: 32,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 32
      }
    },
    {
      if: {
        interactive: true,
        padding: 'narrow',
        viewport: [ 'md', 'lg', 'xl' ]
      },
      tokens: {
        paddingBottom: 29,
        paddingLeft: 13,
        paddingRight: 13,
        paddingTop: 29
      }
    },
    {
      if: { padding: 'intermediate' },
      tokens: {
        paddingBottom: 24,
        paddingLeft: 24,
        paddingRight: 24,
        paddingTop: 24
      }
    },
    {
      if: { interactive: true, padding: 'intermediate' },
      tokens: {
        paddingBottom: 21,
        paddingLeft: 21,
        paddingRight: 21,
        paddingTop: 21
      }
    },
    {
      if: { padding: 'intermediate', viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        paddingBottom: 32,
        paddingLeft: 32,
        paddingRight: 32,
        paddingTop: 32
      }
    },
    {
      if: {
        interactive: true,
        padding: 'intermediate',
        viewport: [ 'md', 'lg', 'xl' ]
      },
      tokens: {
        paddingBottom: 29,
        paddingLeft: 29,
        paddingRight: 29,
        paddingTop: 29
      }
    },
    {
      if: { padding: 'compact' },
      tokens: {
        paddingBottom: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingTop: 16
      }
    },
    {
      if: { interactive: true, padding: 'compact' },
      tokens: {
        paddingBottom: 13,
        paddingLeft: 13,
        paddingRight: 13,
        paddingTop: 13
      }
    },
    {
      if: { padding: 'custom' },
      tokens: {
        paddingBottom: 0,
        paddingLeft: 0,
        paddingRight: 0,
        paddingTop: 0
      }
    },
    {
      if: { interactive: true },
      tokens: { backgroundColor: 'transparent' }
    },
    {
      if: {
        focus: false,
        interactive: true,
        isControl: false,
        pressed: false
      },
      tokens: { borderColor: '#ffffff', borderWidth: 2 }
    },
    {
      if: { focus: false, interactive: true, pressed: false },
      tokens: { borderColor: 'rgba(0, 0, 0, 0)', borderWidth: 2 }
    },
    {
      if: { hover: true, interactive: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        borderColor: 'transparent'
      }
    },
    {
      if: { focus: true, interactive: true },
      tokens: { borderColor: '#4b286d', borderWidth: 2 }
    },
    {
      if: { interactive: true, pressed: true },
      tokens: {
        backgroundColor: 'rgba(0, 0, 0, 0.1)',
        borderColor: '#e3e6e8',
        borderWidth: 2
      }
    },
    {
      if: { interactive: true, isControl: false, selected: true },
      tokens: {
        backgroundColor: '#f4f4f7',
        borderColor: '#4b286d',
        borderWidth: 1
      }
    },
    {
      if: { hover: true, interactive: true, style: 'dark' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
    },
    {
      if: { hover: true, interactive: true, style: 'darker' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
    },
    {
      if: { hover: true, interactive: true, style: 'darkest' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.1)' }
    },
    {
      if: { interactive: true, pressed: true, style: 'dark' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
    },
    {
      if: { interactive: true, pressed: true, style: 'darker' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
    },
    {
      if: { interactive: true, pressed: true, style: 'darkest' },
      tokens: { backgroundColor: 'rgba(255, 255, 255, 0.2)' }
    }
  ],
  tokens: {
    backgroundColor: '#ffffff',
    backgroundGradient: null,
    borderColor: '#e3e6e8',
    borderRadius: 6,
    borderWidth: 1,
    contentAlignItems: 'stretch',
    contentFlexGrow: 0,
    contentFlexShrink: 1,
    contentJustifyContent: 'flex-start',
    flex: 1,
    gradient: null,
    icon: PaletteIconCheckbold,
    iconBackgroundColor: '#f4f4f7',
    iconColor: '#4b286d',
    iconSize: 20,
    inputBackgroundColor: '#f4f4f7',
    inputBorderColor: 'rgba(0, 0, 0, 0)',
    inputBorderRadius: 4,
    inputBorderWidth: 0,
    inputHeight: 32,
    inputShadow: {
      blur: 2,
      color: 'rgba(0, 0, 0, 0.1)',
      inset: true,
      offsetX: 0,
      offsetY: 2,
      spread: 0
    },
    inputWidth: 32,
    maxHeight: '100%',
    minWidth: null,
    overflowY: 'visible',
    paddingBottom: 32,
    paddingLeft: 24,
    paddingRight: 24,
    paddingTop: 32,
    shadow: null
  }
}
export default theme
